import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { FormikProps } from "formik";

import { EdictSource } from "@/api";
import { FormikDatePicker } from "@/common/components/fields/formik/formik-date-picker/FormikDatePicker";
import { EdictFilterValues } from "@/pages/edicts/Edicts.types";
import { useTranslation } from "@/translations";

import { EdictSourceToggle } from "../source-toggle/EdictSourceToggle";

interface Props {
  formik: FormikProps<EdictFilterValues>;
  onSourceChange: (source: EdictSource) => void;
  onlyWithoutCounselor: boolean;
  onOnlyWithoutCounselorChange: (value: boolean) => void;
}

export function EdictsFilterBar({ formik, onSourceChange, onlyWithoutCounselor, onOnlyWithoutCounselorChange }: Props) {
  const { t } = useTranslation();

  return (
    <Box display="flex" alignItems="flex-start" gap={3} flexWrap="wrap">
      <EdictSourceToggle value={formik.values.source} onChange={onSourceChange} />
      <Box sx={{ minWidth: 180 }}>
        <FormikDatePicker fieldName="from" label={t("edicts.filter.from")} formik={formik} />
      </Box>
      <Box sx={{ minWidth: 180 }}>
        <FormikDatePicker fieldName="to" label={t("edicts.filter.to")} formik={formik} />
      </Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={onlyWithoutCounselor}
            onChange={(event) => onOnlyWithoutCounselorChange(event.target.checked)}
            slotProps={{ input: { "aria-label": t("edicts.filter.onlyWithoutCounselor") } }}
          />
        }
        label={t("edicts.filter.onlyWithoutCounselor")}
      />
    </Box>
  );
}
